import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeotabLcService {

  private readonly geotablcSubject = new Subject<string>();

  geotablc$ = this.geotablcSubject.asObservable();

  /* istanbul ignore next */
  updateLifecycle(lifecycle: string) {
    this.geotablcSubject.next(lifecycle);
  }
}
